import app from 'flarum/forum/app';
app.initializers.add('val-ui-mobile-picker-position', () => {
  const selector = '.Composer .val-emoji-panel,' + '.Composer .val-smiley-panel,' + '.Composer .val-model-panel';
  let raf = 0;
  const place = panel => {
    if (window.innerWidth > 767) {
      panel.style.removeProperty('--val-panel-top');
      panel.style.removeProperty('--val-panel-max-height');
      return;
    }
    const composer = panel.closest('.Composer');
    const controls = composer?.querySelector('.TextEditor-controls');
    if (!controls) return;
    const controlsRect = controls.getBoundingClientRect();

    /*
     * Toute la hauteur disponible entre le haut de l'écran
     * et la barre d'outils, avec 12 px de marge en haut
     * et 10 px au-dessus des boutons.
     */
    const available = Math.max(120, Math.floor(controlsRect.top - 22));
    const maxHeight = Math.min(320, available);
    panel.style.setProperty('--val-panel-max-height', `${maxHeight}px`);

    /*
     * Lecture de la hauteur après application du max-height.
     */
    const panelHeight = panel.getBoundingClientRect().height;
    const top = Math.max(12, Math.floor(controlsRect.top - panelHeight - 10));
    panel.style.setProperty('--val-panel-top', `${top}px`);
  };
  const sync = () => {
    raf = 0;
    document.querySelectorAll(selector).forEach(place);
  };
  const schedule = () => {
    if (raf) return;
    raf = requestAnimationFrame(sync);
  };
  const observer = new MutationObserver(schedule);
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  window.addEventListener('resize', schedule);
  window.addEventListener('scroll', schedule, true);
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', schedule);
    window.visualViewport.addEventListener('scroll', schedule);
  }
  schedule();
});